import React, { Suspense, lazy } from 'react';
import Hero from '../components/Hero';
import Features from '../components/Features';
import Benefits from '../components/Benefits';
import TradingInstruments from '../components/TradingInstruments';
import Stats from '../components/Stats';

const Platforms = lazy(() => import('../components/Platforms'));
const Testimonials = lazy(() => import('../components/Testimonials'));
const FAQ = lazy(() => import('../components/FAQ'));
const CTA = lazy(() => import('../components/CTA'));

export default function Home() {
  return (
    <div className="min-h-screen bg-background">
      <Hero />
      <Stats />
      <Features />
      <TradingInstruments />
      <Benefits />

      <section className="py-16 bg-white">
        <div className="container mx-auto px-4 sm:px-6 lg:px-8 max-w-4xl">
          <h2 className="text-2xl sm:text-3xl font-bold text-gray-900 mb-4">About Synthetic Trading Hub</h2>
          <p className="text-base sm:text-lg text-gray-700 leading-relaxed">
            Synthetic Trading Hub is an independent educational platform that provides guidance on synthetic trading and helps users
            understand how to get started safely using platforms like Deriv.
          </p>
        </div>
      </section>
      <Suspense fallback={null}>
        <Platforms />
        <Testimonials />
        <FAQ />
        <CTA />
      </Suspense>
    </div>
  );
}
